<template>
  <div class="knowlitem-space">
    <div>
      <know-banner></know-banner>
    </div>
    <div class="knowledge-news">
      <el-row>
        <el-col :span="18">
          <div>
            <h2 class="know_item_title">权威报告</h2>
            <div class="doc-module-item" v-for="(item,index) in authoritativeList" :key="index">
              <div class="hr-type">
                <el-divider></el-divider>
              </div>
              <div>
                <el-row>
                  <el-col :span="6">
                    <div class="doc-module-img" @click="seeDocInfo(item.newsId)">
                      <img :src="item.newsMainImg" width="220" height="155" alt="">
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div>
                      <h3 @click="seeDocInfo(item.newsId)">{{item.newsTitle}}</h3>
                      <el-row>
                        <el-col :span='6'><span>时间：{{item.newsDate}}</span></el-col>
                        <el-col :span='8'><span>作者：{{item.newsCreateUserName}}</span></el-col>
                      </el-row>
                      <div>{{item.newsSummary}}</div>
                      <!-- <el-button type="text" class="know_module_more" @click="seeDocInfo(item.newsId)">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="news_page">
            <el-pagination :page-size="aPageSize" layout="prev, pager, next" :total="atotalPage" @current-change="turnPage" background class="pager_style">
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="6">
          <top-news v-bind:newsType="newsType"></top-news>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import knowBanner from './knowBanner';
import topNews from './topNews';
import { sysNewsData } from '@/api/frontApi/common';
export default {
  data() {
    return {
      authoritativeList: [],
      newsType: 11,
      keyWord: '',
      topTenList: [],
      isList: true,
      aPageNo: 1,
      aPageSize: 5,
      atotalPage: 1
    };
  },
  components: {
    knowBanner,
    topNews
  },
  created() {
    this.initAuthoritative();
  },
  methods: {
    initAuthoritative() {
      let params = {
        pageNo: this.aPageNo,
        pageSize: this.aPageSize,
        newsType: this.newsType
      };
      sysNewsData(params).then(res => {
        if (res.result.code === 0) {
          this.authoritativeList = [];
          this.authoritativeList = res.data.list;
          this.atotalPage = res.data.totalCount;
        }
      });
    },
    seeDocInfo(textId) {
      this.$router.push({
        name: 'knowInfo',
        params: { knowledgeId: textId }
      });
    },
    turnPage(val) {
      this.aPageNo = val;
      this.initAuthoritative();
    }
  }
};
</script>
<style scoped>
.hr-type {
  width: 93%;
}
.doc-module-img {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/knowledge/authoritative.vue